<section id="main-container">
  <a [href]="previousUrl" class="full-orange previous">Voltar</a>
  <app-loader-circles *ngIf="loading; else loaded"></app-loader-circles>

  <ng-template #loaded>
    <div *ngIf="proposta" class="container-fluid proposal-data">
      <div class="row">
        <div class="col-xs-12">
          <div class="head"><h1>Informações da Proposta {{ proposta.id }}</h1></div>
        </div>
      </div>
      <div class="row">
        <section class="col-xs-12 col-md-4 box" *ngIf="proposta">
          <div class="row box-head">
            <h2 class="col-xs-9 box-head-text">
              Dados da Proposta
            </h2>
            <button class="col-xs-3 btn button-open-close full-orange" (click)="exibirDados['proposta'] = !exibirDados['proposta']">
              {{ boolText(exibirDados['proposta']) }}
            </button>
          </div>
          <section *ngIf="exibirDados['proposta']">
            <div class="row">
              <div class="col-xs-12">
                <h3>Valor</h3>
                <div class="value">{{ formatCurrency(proposta.valorLiquido) }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <h3>Quantidade de Parcelas</h3>
                <div class="value">{{ proposta.qtdeParcelas }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <h3>Valor por Parcela</h3>
                <div class="value">{{ formatCurrency(proposta.valorParcela) }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <h3>Valor Total (Valor por Parcela x Parcelas)</h3>
                <div class="value">{{ formatCurrency(proposta.valorParcela * 12) }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <h3>Tem Seguro?</h3>
                <div class="value">{{ proposta.seguro ? 'Sim' : 'Não' }}</div>
              </div>
            </div>
            <div *ngIf="proposta.operacao">
              <div class="row">
                <div class="col-xs-12">
                  <h3>Operação</h3>
                  <div class="value">{{ proposta.produto }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <h3>Código da Operação</h3>
                  <div class="value">{{ proposta.operacao.id + ' - ' + proposta.operacao.descricao }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <h3>Quantidade de Avalistas</h3>
                  <div class="value">{{ avalistas.length }}</div>
                </div>
              </div>
            </div>
          </section>
        </section>
        <section class="col-xs-12 col-md-4 box" *ngFor="let cliente of clienteEAvalistasBoxes">
          <div class="row box-head">
            <h2 class="col-xs-9 box-head-text">
              {{ cliente.title }}
            </h2>
            <button class="col-xs-3 btn button-open-close full-orange" (click)="exibirDados[cliente.type] = !exibirDados[cliente.type]">
              {{ boolText(exibirDados[cliente.type]) }}
            </button>
          </div>
          <section *ngIf="exibirDados[cliente.type]">
            <div class="row" *ngIf="cliente.apelidoCliente">
              <div class="col-xs-12">
                <h3>Apelido</h3>
                <div class="value">{{ cliente.apelidoCliente }}</div>
              </div>
            </div>
            <div class="row" *ngIf="cliente.nomeCliente">
              <div class="col-xs-12">
                <h3>Cliente</h3>
                <div class="value">{{ cliente.nomeCliente }}</div>
              </div>
            </div>
            <div class="row" *ngIf="cliente.cpf">
              <div class="col-xs-12">
                <h3>CPF</h3>
                <div class="value">{{ cliente.cpf }}</div>
              </div>
            </div>
            <div class="row" *ngIf="cliente.email">
              <div class="col-xs-12">
                <h3>E-mail</h3>
                <a [href]="'mailto:' + cliente.email" class="value">{{ cliente.email }}</a>
              </div>
            </div>
            <div class="row" *ngIf="cliente.dtNascimento">
              <div class="col-xs-12">
                <h3>Data de Nascimento</h3>
                <div class="value">{{ formatDate(cliente.dtNascimento) }}</div>
              </div>
            </div>
            <div class="row" *ngIf="cliente.estadoCivil && cliente.estadoCivil.descricao">
              <div class="col-xs-12">
                <h3>Estado Civil</h3>
                <div class="value">{{ cliente.estadoCivil.descricao }}</div>
              </div>
            </div>
            <div class="row" *ngIf="cliente.sexo">
              <div class="col-xs-12">
                <h3>Gênero</h3>
                <div class="value">{{ generos[cliente.sexo] }}</div>
              </div>
            </div>
            <div *ngIf="cliente.telefones">
              <div class="row" *ngFor="let telefone of cliente.telefones">
                <div class="col-xs-12">
                  <h3>Telefone {{ telefone.categoriaTelefone }}</h3>
                  <a [href]="'tel:' + telefone.ddd + telefone.nrTelefone" class="value">{{ telefone.ddd + ' ' + telefone.nrTelefone }}</a>
                </div>
              </div>
            </div>
            <div class="row" *ngIf="cliente.nomeMae">
              <div class="col-xs-12">
                <h3>Nome da Mãe</h3>
                <div class="value">{{ cliente.nomeMae }}</div>
              </div>
            </div>
            <div class="row" *ngIf="cliente.nomePai">
              <div class="col-xs-12">
                <h3>Nome do Pai</h3>
                <div class="value">{{ cliente.nomePai }}</div>
              </div>
            </div>
            <div class="row" *ngIf="cliente.nacionalidade && cliente.nacionalidade.descricao">
              <div class="col-xs-12">
                <h3>Nacionalidade</h3>
                <div class="value">{{ cliente.nacionalidade.descricao }}</div>
              </div>
            </div>
            <div class="row" *ngIf="cliente.naturalDe && cliente.naturalDeUf">
              <div class="col-xs-12">
                <h3>Natural de</h3>
                <div class="value">{{ cliente.naturalDe + ' - ' + cliente.naturalDeUf }}</div>
              </div>
            </div>
            <div class="row" *ngIf="cliente.fatca">
              <div class="col-xs-12">
                <h3>Fatca</h3>
                <div class="value">{{ cliente.fatca }}</div>
              </div>
            </div>
            <div class="row" *ngIf="![null, undefined].includes(cliente.ppe)">
              <div class="col-xs-12">
                <h3>Politicamente Exposto?</h3>
                <div class="value">{{ cliente.ppe ? 'Sim' : 'Não' }}</div>
              </div>
            </div>
            <div class="row" *ngIf="![null, undefined].includes(cliente.dependentes)">
              <div class="col-xs-12">
                <h3>Número de dependentes</h3>
                <div class="value">{{ cliente.dependentes || 0 }}</div>
              </div>
            </div>
            <div class="row" *ngIf="![null, undefined].includes(cliente.valorTotalPatrimonio)">
              <div class="col-xs-12">
                <h3>Valor Total do Patrimônio</h3>
                <div class="value">{{ formatCurrency(cliente.valorTotalPatrimonio || 0) }}</div>
              </div>
            </div>
            <div *ngIf="cliente.dadosProfissionais && cliente.dadosProfissionais.classeProfissional && cliente.dadosProfissionais.classeProfissional.descricao">
              <div class="row">
                <div class="col-xs-12">
                  <h3>Classe Profissional</h3>
                  <div class="value">{{ cliente.dadosProfissionais.classeProfissional.descricao }}</div>
                </div>
              </div>
              <div class="row" *ngIf="cliente.type === 'cliente' && clienteProfissaoDescricao">
                <div class="col-xs-12">
                  <h3>Profissão</h3>
                  <div class="value">{{ clienteProfissaoDescricao }}</div>
                </div>
              </div>
            </div>
          </section>
        </section>
        <section class="col-xs-12 col-md-4 box" *ngIf="proposta.cliente && proposta.cliente.referencias">
          <div class="row box-head">
            <h2 class="col-xs-9 box-head-text">
              Dados de Referências
            </h2>
            <button class="col-xs-3 btn button-open-close full-orange" (click)="exibirDados['referencia'] = !exibirDados['referencia']">
              {{ boolText(exibirDados['referencia']) }}
            </button>
          </div>
          <section *ngIf="exibirDados['referencia']">
            <div *ngFor="let referencia of proposta.cliente.referencias; let i = index;">
              <div class="row">
                <div class="col-xs-12">
                  <h3>Nome da Referência {{ proposta.cliente.referencias.length > 1 ? i + 1 : '' }}</h3>
                  <div class="value">{{ referencia.nome }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <h3>Telefone {{ proposta.cliente.referencias.length > 1 ? i + 1 : '' }}</h3>
                  <a [href]="'tel:' + referencia.ddd + referencia.nrTelefone" class="value">{{ referencia.ddd + ' ' + referencia.nrTelefone }}</a>
                </div>
              </div>
              <div class="row" *ngIf="referencia.tipoReferencia && referencia.tipoReferencia.id">
                <div class="col-xs-12">
                  <h3>Tipo da Referência {{ proposta.cliente.referencias.length > 1 ? i + 1 : '' }}</h3>
                  <div class="value">{{ tipoReferencias[referencia.tipoReferencia.id] }}</div>
                </div>
              </div>
            </div>
          </section>
        </section>
        <section class="col-xs-12 col-md-4 box" *ngIf="proposta.conjuge && proposta.conjuge.cpf">
          <div class="row box-head">
            <h2 class="col-xs-9 box-head-text">
              Dados do Conjuge
            </h2>
            <button class="col-xs-3 btn button-open-close full-orange" (click)="exibirDados['conjuge'] = !exibirDados['conjuge']">
              {{ boolText(exibirDados['conjuge']) }}
            </button>
          </div>
          <section *ngIf="exibirDados['conjuge']">
            <div class="row">
              <div class="col-xs-12">
                <h3>CPF</h3>
                <div class="value">{{ proposta.conjuge.cpf }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <h3>Data de Nascimento</h3>
                <div class="value">{{ formatDate(proposta.conjuge.dtNascimento) }}</div>
              </div>
            </div>
            <div *ngIf="proposta.conjuge.dadosProfissionais">
              <div class="row">
                <div class="col-xs-12">
                  <h3>Classe Profissional</h3>
                  <div class="value">{{ proposta.conjuge.dadosProfissionais.classeProfissional.descricao }}</div>
                </div>
              </div>
              <div class="row" *ngIf="conjugeProfissaoDescricao">
                <div class="col-xs-12">
                  <h3>Profissão</h3>
                  <div class="value">{{ conjugeProfissaoDescricao }}</div>
                </div>
              </div>
            </div>
          </section>
        </section>
        <section class="col-xs-12 col-md-4 box" *ngIf="proposta.favorecido && proposta.favorecido.banco">
          <div class="row box-head">
            <h2 class="col-xs-9 box-head-text">
              Dados Bancários
            </h2>
            <button class="col-xs-3 btn button-open-close full-orange" (click)="exibirDados['favorecido'] = !exibirDados['favorecido']">
              {{ boolText(exibirDados['favorecido']) }}
            </button>
          </div>
          <section *ngIf="exibirDados['favorecido']">
            <div class="row">
              <div class="col-xs-12">
                <h3>Banco</h3>
                <div class="value">{{ nomeBancoFavorecido || proposta.favorecido.banco }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <h3>Agência</h3>
                <div class="value">{{ proposta.favorecido.agencia }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <h3>Conta Corrente</h3>
                <div class="value">{{ proposta.favorecido.contaCorrente + (proposta.favorecido.digitoContaCorrente ? '-' + proposta.favorecido.digitoContaCorrente : '') }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <h3>Favorecido</h3>
                <div class="value">{{ proposta.favorecido.favorecido }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <h3>Nome do Favorecido</h3>
                <div class="value">{{ proposta.favorecido.nomeFavorecido }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <h3>CPF/CNPJ do Favorecido</h3>
                <div class="value">{{ proposta.favorecido.cpfCnpj }}</div>
              </div>
            </div>
          </section>
        </section>
        <div *ngIf="proposta.cliente && proposta.cliente.enderecos">
          <section class="col-xs-12 col-md-4 box" *ngFor="let endereco of proposta.cliente.enderecos">
            <div class="row box-head">
              <h2 class="col-xs-9 box-head-text">
                Endereço {{ endereco.tipoEndereco }}
              </h2>
              <button class="col-xs-3 btn button-open-close full-orange" (click)="endereco.tipoEndereco === 'RESIDENCIAL' ? (exibirDados['enderecoResidencial'] = !exibirDados['enderecoResidencial']) : (exibirDados['enderecoComercial'] = !exibirDados['enderecoComercial'])">
                {{ boolText(endereco.tipoEndereco === 'RESIDENCIAL' ? exibirDados['enderecoResidencial'] : exibirDados['enderecoComercial']) }}
              </button>
            </div>
            <section *ngIf="endereco.tipoEndereco === 'RESIDENCIAL' ? exibirDados['enderecoResidencial'] : exibirDados['enderecoComercial']">
              <div class="row">
                <div class="col-xs-12">
                  <h3>CEP</h3>
                  <div class="value">{{ endereco.cep }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <h3>Endereço</h3>
                  <div class="value">{{ endereco.logradouro }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <h3>Bairro</h3>
                  <div class="value">{{ endereco.bairro }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <h3>Cidade</h3>
                  <div class="value">{{ endereco.cidade }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <h3>UF</h3>
                  <div class="value">{{ endereco.uf }}</div>
                </div>
              </div>
            </section>
          </section>
        </div>
      </div>
      <div *ngIf="faef">
        <div class="row">
          <div class="col-xs-12">
            <div class="head"><h1>Informações da FAEF</h1></div>
          </div>
        </div>
        <div class="row">
          <section class="col-xs-12 col-md-4 box" *ngIf="faef.faefResultado">
            <div class="row box-head">
              <h2 class="col-xs-9 box-head-text">
                Parecer do Agente
              </h2>
              <button class="col-xs-3 btn button-open-close full-orange" (click)="exibirDados['parecerAgente'] = !exibirDados['parecerAgente']">
                {{ boolText(exibirDados['parecerAgente']) }}
              </button>
            </div>
            <section *ngIf="exibirDados['parecerAgente']">
              <div class="row">
                <div class="col-xs-12">
                  <h3>Nota de Confiança</h3>
                  <div class="value">{{ faef.faefResultado.notaConfiancaCliente }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <h3>Quanto emprestaria?</h3>
                  <div class="value">{{ formatCurrency(faef.faefResultado.valorEmprestaria) }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <h3>Parecer</h3>
                  <div class="value">{{ faef.faefResultado.parecerAgente }}</div>
                </div>
              </div>
            </section>
          </section>
          <section class="col-xs-12 col-md-4 box" *ngIf="faef && faef.faefFinanceiroEmpreendimento">
            <div class="row box-head">
              <h2 class="col-xs-9 box-head-text">
                Dados Financeiros
              </h2>
              <button class="col-xs-3 btn button-open-close full-orange" (click)="exibirDados['financeiro'] = !exibirDados['financeiro']">
                {{ boolText(exibirDados['financeiro']) }}
              </button>
            </div>
            <section *ngIf="exibirDados['financeiro']">
              <div class="row">
                <div class="col-xs-12">
                  <h3>Despesas Operacionais do Negócio</h3>
                  <div class="value">{{ formatCurrency(faef.faefFinanceiroEmpreendimento.despesasOperacionaisNegocio) }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <h3>Despesas com Alimentação da Família</h3>
                  <div class="value">{{ formatCurrency(faef.faefFinanceiroEmpreendimento.despesasAlimentacaoFamilia) }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <h3>Despesas com Aluguel Residencial</h3>
                  <div class="value">{{ formatCurrency(faef.faefFinanceiroEmpreendimento.despesasAluguelResidencial) }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <h3>Despesas com Vestuário na Família</h3>
                  <div class="value">{{ formatCurrency(faef.faefFinanceiroEmpreendimento.despesasVestuarioFamilia) }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <h3>Despesas com Educação na Família</h3>
                  <div class="value">{{ formatCurrency(faef.faefFinanceiroEmpreendimento.despesasEducacaoFamilia) }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <h3>Despesas com Água, Luz, Telefone e Internet na Família</h3>
                  <div class="value">{{ formatCurrency(faef.faefFinanceiroEmpreendimento.despesasServicosDiversos) }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <h3>Despesas com prestações de móveis e eletrodomésticos e outros</h3>
                  <div class="value">{{ formatCurrency(faef.faefFinanceiroEmpreendimento.despesasMoveisEletrodomesticos) }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <h3>Soma da Renda Familiar</h3>
                  <div class="value">{{ formatCurrency(faef.faefFinanceiroEmpreendimento.somaRendaFamiliar) }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <h3>Soma Valor em Caixa e Bancos Hoje</h3>
                  <div class="value">{{ formatCurrency(faef.faefFinanceiroEmpreendimento.somaCaixaBanco) }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <h3>Contas a Receber</h3>
                  <div class="value">{{ formatCurrency(faef.faefFinanceiroEmpreendimento.contasReceber) }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <h3>Estoque</h3>
                  <div class="value">{{ formatCurrency(faef.faefFinanceiroEmpreendimento.estoque) }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <h3>Veículos</h3>
                  <div class="value">{{ formatCurrency(faef.faefFinanceiroEmpreendimento.veiculos) }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <h3>Máquinas e Equipamentos</h3>
                  <div class="value">{{ formatCurrency(faef.faefFinanceiroEmpreendimento.maquinasEquipamentos) }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <h3>Dívidas com Fornecedores</h3>
                  <div class="value">{{ formatCurrency(faef.faefFinanceiroEmpreendimento.dividaFornecedores) }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <h3>Contas a Pagar em Geral</h3>
                  <div class="value">{{ formatCurrency(faef.faefFinanceiroEmpreendimento.contasPagar) }}</div>
                </div>
              </div>
            </section>
          </section>
          <section class="col-xs-12 col-md-4 box" *ngIf="faef.faefComercio && faef.faefComercio.length > 0">
            <div class="row box-head">
              <h2 class="col-xs-9 box-head-text">
                Dados da Mercadoria
              </h2>
              <button class="col-xs-3 btn button-open-close full-orange" (click)="exibirDados['mercadoria'] = !exibirDados['mercadoria']">
                {{ boolText(exibirDados['mercadoria']) }}
              </button>
            </div>
            <section *ngIf="exibirDados['mercadoria']">
              <div *ngFor="let comercio of faef.faefComercio; let i = index">
                <div class="row" [ngClass]="{'border-top': i > 0}">
                  <div class="col-xs-12">
                    <h3>Nome da Mercadoria</h3>
                    <div class="value">{{ comercio.nomeMercadoria }}</div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12">
                    <h3>Preço de Compra</h3>
                    <div class="value">{{ formatCurrency(comercio.precoUnitarioCompra) }}</div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12">
                    <h3>Preço de Venda</h3>
                    <div class="value">{{ formatCurrency(comercio.precoUnitarioVenda) }}</div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12">
                    <h3>Quantidade em Estoque</h3>
                    <div class="value">{{ comercio.quantidadeEstoque }}</div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12">
                    <h3>Quantidade Vendida</h3>
                    <div class="value">{{ comercio.quantidadeVendida }}</div>
                  </div>
                </div>
              </div>
            </section>
          </section>
          <section class="col-xs-12 col-md-4 box" *ngIf="faef.faefCompras">
            <div class="row box-head">
              <h2 class="col-xs-9 box-head-text">
                Dados de Compras
              </h2>
              <button class="col-xs-3 btn button-open-close full-orange" (click)="exibirDados['compra'] = !exibirDados['compra']">
                {{ boolText(exibirDados['compra']) }}
              </button>
            </div>
            <section *ngIf="exibirDados['compra']">
              <div class="row">
                <div class="col-xs-12">
                  <h3>Há 1 mês</h3>
                  <div class="value">{{ formatCurrency(faef.faefCompras.comprasAUmMes) }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <h3>Há 2 meses</h3>
                  <div class="value">{{ formatCurrency(faef.faefCompras.comprasADoisMeses) }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <h3>Há 3 meses</h3>
                  <div class="value">{{ formatCurrency(faef.faefCompras.comprasATresMeses) }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <h3>Porcentagem de Compras a Vista</h3>
                  <div class="value">{{ faef.faefCompras.percentualComprasAVista }}%</div>
                </div>
              </div>
            </section>
          </section>
          <section class="col-xs-12 col-md-4 box" *ngIf="faef.faefVendas">
            <div class="row box-head">
              <h2 class="col-xs-9 box-head-text">
                Dados de Vendas
              </h2>
              <button class="col-xs-3 btn button-open-close full-orange" (click)="exibirDados['venda'] = !exibirDados['venda']">
                {{ boolText(exibirDados['venda']) }}
              </button>
            </div>
            <section *ngIf="exibirDados['venda']">
              <div class="row">
                <div class="col-xs-12">
                  <h3>Há 1 mês</h3>
                  <div class="value">{{ formatCurrency(faef.faefVendas.valorAUmMes) }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <h3>Há 2 meses</h3>
                  <div class="value">{{ formatCurrency(faef.faefVendas.valorADoisMeses) }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <h3>Há 3 meses</h3>
                  <div class="value">{{ formatCurrency(faef.faefVendas.valorATresMeses) }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <h3>Prazo Concedido aos Clientes</h3>
                  <div class="value">{{ vendasPrazoCliente[faef.faefVendas.faefPrazoCliente] }}</div>
                </div>
              </div>
            </section>
          </section>
          <section class="col-xs-12 col-md-4 box" *ngIf="faef.faefVendasMedia">
            <div class="row box-head">
              <h2 class="col-xs-9 box-head-text">
                Dados de Vendas por Mês
              </h2>
              <button class="col-xs-3 btn button-open-close full-orange" (click)="exibirDados['vendaPorMes'] = !exibirDados['vendaPorMes']">
                {{ boolText(exibirDados['vendaPorMes']) }}
              </button>
            </div>
            <section *ngIf="exibirDados['vendaPorMes']">
              <div class="row">
                <div class="col-xs-12">
                  <h3>Valor Médio Bom</h3>
                  <div class="value">{{ formatCurrency(faef.faefVendasMedia.valorMesBom) }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <h3>Valor Médio Regular</h3>
                  <div class="value">{{ formatCurrency(faef.faefVendasMedia.valorMesRegular) }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <h3>Valor Médio Ruim</h3>
                  <div class="value">{{ formatCurrency(faef.faefVendasMedia.valorMesRuim) }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <h3>Meses em que ocorrem as vendas</h3>
                  <div class="value" *ngFor="let mediaMes of mediaMeses">
                    <div *ngIf="mesesVenda[mediaMes]">
                      {{ mediaMes }}: {{ mesesVenda[mediaMes].join(', ') }}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </section>
          <section class="col-xs-12 col-md-4 box" *ngIf="faef.faefResultado">
            <div class="row box-head">
              <h2 class="col-xs-9 box-head-text">
                Indicadores
              </h2>
              <button class="col-xs-3 btn button-open-close full-orange" (click)="exibirDados['indicador'] = !exibirDados['indicador']">
                {{ boolText(exibirDados['indicador']) }}
              </button>
            </div>
            <section *ngIf="exibirDados['indicador']">
              <div class="row">
                <div class="col-xs-12">
                  <h3>Indice Liquidez Seca</h3>
                  <div class="value">{{ faef.faefResultado.indiceLiquidezSeca | number:'1.2-5' }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <h3>Indice Liquidez Corrente</h3>
                  <div class="value">{{ faef.faefResultado.indiceLiquidezCorrente | number:'1.2-5' }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <h3>Indice Liquidez imediata</h3>
                  <div class="value">{{ faef.faefResultado.indiceLiquidezImediata | number:'1.2-5' }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <h3>Percentual de Endividamento</h3>
                  <div class="value">{{ faef.faefResultado.percentualEndividamento | number:'1.2-2' }}%</div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <h3>ROA (Retorno sobre Ativos)</h3>
                  <div class="value">{{ faef.faefResultado.roa | number:'1.2-3' }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <h3>ROE (Retorno sobre patrimônio)</h3>
                  <div class="value">{{ faef.faefResultado.roe | number:'1.2-3' }}</div>
                </div>
              </div>
            </section>
          </section>
        </div>
      </div>
    </div>
  </ng-template>
</section>
